module.exports = __webpack_public_path__ + "img/helper_phone@2x.1eace67f.png";